import { useState } from 'react';
import { Modal } from './ui/Modal.jsx';
import { useInstall } from '../hooks.js';
import { Icon } from './ui/Icon.jsx';
import { t } from '../i18n/index.js';

/*
  Namestitev na domači zaslon.

  Prejšnja verzija je nad vsako stranjo držala oranžen pas „Namesti
  aplikacijo“, ki se ni dal odsloviti — tudi tečajniku, ki namestitve ni
  hotel. Tu je gumb v glavi in ga je mogoče trajno skriti.
*/

const DISMISS_KEY = 'perut-install-dismissed';

const isDismissed = () => {
  try {
    return localStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
};

export function InstallButton({ onNeedHelp, block = false, compact = false }) {
  const { canPrompt, standalone, alreadyInstalled, install } = useInstall();
  const [hidden, setHidden] = useState(isDismissed);

  // Ne ponujaj namestitve, če app že teče nameščen, če je bil kdaj nameščen,
  // ali če je uporabnik ponudbo odslovil.
  if (standalone || alreadyInstalled || hidden) return null;

  const click = async () => {
    const handled = await install();
    if (!handled) onNeedHelp?.();
  };

  return (
    <span className="row" style={{ gap: 'var(--s-1)', width: block ? '100%' : 'auto' }}>
      <button
        className={`btn btn--secondary${compact ? ' btn--sm' : ''}${block ? ' btn--block' : ''}`}
        onClick={click}
        /* Na ozkem zaslonu napis odpade in gumb bi ostal brez imena —
           ikona je za bralnik zaslona nevidna. */
        aria-label={t('Namesti aplikacijo')}
      >
        <Icon name="install" size={16} />
        <span className={compact ? 'hide-narrow' : undefined}>
          {compact ? t('Namesti') : t('Namesti aplikacijo')}
        </span>
      </button>

      {!canPrompt && (
        <button
          className="btn-icon btn-icon--sm"
          aria-label={t('Ne prikazuj več')}
          title={t('Ne prikazuj več')}
          onClick={() => {
            try {
              localStorage.setItem(DISMISS_KEY, '1');
            } catch {
              /* ni ključno */
            }
            setHidden(true);
          }}
        >
          <Icon name="x" size={14} />
        </button>
      )}
    </span>
  );
}

export function InstallHelpModal({ onClose }) {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  return (
    <Modal
      size="sm"
      eyebrow={t('Namestitev')}
      title={t('Dodaj na domači zaslon')}
      onClose={onClose}
      footer={
        <button className="btn btn--primary" onClick={onClose} data-autofocus>
          {t('Razumem')}
        </button>
      }
    >
      <div className="stack">
        <p className="t-md t-dim">
          {t('Hitrejši dostop, ikona na zaslonu, odpre se brez brskalnika.')}
        </p>

        <ol className="stack stack--tight t-md" style={{ paddingLeft: '1.2rem' }}>
          {isIOS ? (
            <>
              <li>
                {t('Tapni gumb')} <strong>{t('Deli')}</strong> {t('(kvadratek s puščico) na dnu zaslona.')}
              </li>
              <li>
                {t('Pomakni se navzdol in tapni')} <strong>{t('„Dodaj na začetni zaslon“')}</strong>.
              </li>
              <li>
                {t('Potrdi z')} <strong>{t('„Dodaj“')}</strong>.
              </li>
            </>
          ) : (
            <>
              <li>
                {t('Tapni meni')} <strong>⋮</strong> {t('v zgornjem desnem kotu.')}
              </li>
              <li>
                {t('Izberi')} <strong>{t('„Namesti aplikacijo“')}</strong> {t('ali')}{' '}
                <strong>{t('„Dodaj na začetni zaslon“')}</strong>.
              </li>
              <li>
                {t('Potrdi z')} <strong>{t('„Namesti“')}</strong>.
              </li>
            </>
          )}
        </ol>
      </div>
    </Modal>
  );
}
